import React from 'react';
import ContentLayout from './ContentLayout';
import ContentLayoutProvider from '../LayoutContext/Providers/ContentLayoutProvider';
import { useContentLayoutContext } from '../LayoutContext/hooks';
import { IContentLayoutProvider } from '../LayoutContext/types';
import { IContentLayout } from './types';

const ContentContextConsumer = (props: IContentLayout) => {
  const context = useContentLayoutContext();
  return <ContentLayout {...context} {...props} />;
};

/**
 * Content Layout Component connected to layout context.
 *
 * Context determined prop values (IContentContext) can be overriden by parent.
 */
const ConnectedContentLayout = ({
  dashboardPaths,
  isDashboard,
  hasPanel,
  ...rest
}: IContentLayout & IContentLayoutProvider): JSX.Element => {
  return (
    <ContentLayoutProvider
      dashboardPaths={dashboardPaths}
      isDashboard={isDashboard}
      hasPanel={hasPanel}
    >
      <ContentContextConsumer {...rest} />
    </ContentLayoutProvider>
  );
};

export default ConnectedContentLayout;
